import { Branch, RequestBranch } from "interfaces/Branch";
import { get, patch, post, remove } from "services/services.methods";
import { BranchPaths } from "services/services.paths";

export const getBranchesByCompany = async (companyId: string) => {
  const response = await get<Branch[]>(
    BranchPaths.getByCompany + `/${companyId}`
  );
  return response;
};

export const FetchBranch = async () => {
  const response = await get<Branch[]>(BranchPaths.get);
  return response;
};

export const CreateBranch = async (data: RequestBranch) => {
  const response = await post<Branch>(BranchPaths.post, data);
  return response;
};

export const UpdateBranch = async (id: number, data: RequestBranch) => {
  const response = await patch<Branch>(BranchPaths.patch + `/${id}`, data);
  return response;
};

export const RemoveBranch = async (id: number) => {
  const response = await remove<Branch>(BranchPaths.delete + `/${id}`);
  return response;
};

export const getBranches = async () => {
  const response = await get<Branch[]>(BranchPaths.get);
  return response.data;
};


export const getBranchesSelect = async () => {
  const response = await get<Branch[]>(BranchPaths.get);
  return response;
};